import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

interface CustomDatePicker {
  label?: string;
  value: dayjs.Dayjs | null;
  onDateChange: (newDate: dayjs.Dayjs | null) => void;
  error?: boolean;
  minDate?: any;
  disabled?: boolean;
  shouldDisableDate?: (date: dayjs.Dayjs) => boolean;
}

const CustomDatePicker = React.forwardRef<HTMLInputElement, CustomDatePicker>(
  (
    {
      label,
      value,
      onDateChange,
      error = false,
      minDate,
      disabled,
      shouldDisableDate,
    },
    ref
  ) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={value}
          minDate={minDate}
          disabled={disabled}
          onChange={onDateChange}
          format="DD/MM/YYYY"
          {...(shouldDisableDate ? { shouldDisableDate } : {})}
          slotProps={{
            textField: {
              size: "small",
              inputRef: ref,
              error: error,
              sx: {
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  backgroundColor: disabled ? "#e1e1e1" : "#FAFBFD",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: disabled ? "none" : undefined,
                  },
                },
                // minWidth: "250px",
              },
            },
          }}
        />
      </LocalizationProvider>
    );
  }
);

export default CustomDatePicker;
